export default "__VITE_ASSET__isQ9iCNc__$_?format=webp__"